module.exports = __webpack_public_path__ + "static/img/fail.298301c5.png";